const orderingProcess = {
  heading: 'Order medications easily and securely from your pharmacies',
  selectiveBlock: {
    heading: 'Get medication quickly',
    paragraph: 'Pre-order medicines directly from us and benefit from the high availability of our range. You will usually receive your order within a few hours.',
  },
  tiles: {
    1: 'Order medication and redeem (e-)prescriptions',
    2: 'Select delivery method',
    3: 'Select payment method',
    4: 'Collect order or receive it by courier service',
  },
}

export default orderingProcess
